/** One handle in the path. What the platform was told about it, and nothing it was not. */

import { DataList, EmptyState, Page, StatusBadge } from "@/components/ui";

import { MarketingShell } from "../marketing/MarketingShell";
import { useSession } from "../marketing/useSession";

const PAGE_PADDING = { paddingBlock: "var(--al-space-7)" };

export function ProfilePage({ handle }: { readonly handle: string }) {
  const { data: account } = useSession();
  const mine = account != null && account.handle.toLowerCase() === handle.toLowerCase();

  return (
    <MarketingShell>
      <Page
        eyebrow="Profile"
        title={`@${mine && account != null ? account.handle : handle}`}
        style={PAGE_PADDING}
      >
        {mine && account != null ? (
          <DataList
            items={[
              {
                id: "account",
                title: account.display_name,
                badge: (
                  <StatusBadge tone={account.state === "active" ? "success" : "neutral"}>
                    {account.state}
                  </StatusBadge>
                ),
                fields: [{ label: "Handle", value: `@${account.handle}`, mono: true }],
              },
            ]}
          />
        ) : (
          <EmptyState headline="Nothing public yet" />
        )}
      </Page>
    </MarketingShell>
  );
}
